import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ExtensionDetail from './pages/ExtensionDetail';
import Dashboard from './pages/Dashboard';
import AdminPanel from './pages/AdminPanel';
import Documentation from './pages/Documentation';
import AIAssistant from './pages/AIAssistant';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import BecomeDeveloper from './pages/BecomeDeveloper';
import BuildExtension from './pages/BuildExtension';
import EditExtension from './pages/EditExtension';
import Settings from './pages/Settings';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-dark-900 text-white">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register/:accountType" element={<Register />} />
          <Route path="/verify-email/:token" element={<VerifyEmail />} />
          <Route path="/extension/:id" element={<ExtensionDetail />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/build" element={<BuildExtension />} />
          <Route path="/edit/:id" element={<EditExtension />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/docs" element={<Documentation />} />
          <Route path="/ai-assistant" element={<AIAssistant />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/developers" element={<BecomeDeveloper />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
        <Footer />
        <ToastContainer
          position="bottom-right"
          theme="dark"
          autoClose={3000}
        />
      </div>
    </Router>
  );
}

export default App;
